import { httpClient } from '@/network/clientController'

/** Gets List of Economic Activities for TPAs requested
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestLovseconomicActivities
*/
export const getListEconomicActivities = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequestLovs/economicActivities',
		isCancellable: true
	})
}

/** Gets List of Authorized Operations for TPAs requested
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestLovsauthorizedOperations
*/
export const getListAuthorizedOperations = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequestLovs/authorizedOperations',
		isCancellable: true
	})
}

/** Gets List of Accepted Cards for TPAs request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestLovsacceptedCards
*/
export const getListAcceptedCards = payload => {
	return httpClient({
		method: 'GET',
		url: 'tpaRequestLovs/acceptedCards',
		isCancellable: true
	})
}
